
module.exports.userJustManager = (claims)=>{
return !claims.isAdmin && !claims.isSuperAdmin && claims.isManager 
} 